var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHeroCircularShapeTradex(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 773,
    height: 773,
    viewBox: "0 0 773 773",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "luminosity"
    },
    opacity: 0.3
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M-0.122164 504.264C64.8206 504.15 117.375 451.412 117.262 386.469C117.148 321.526 64.4101 268.972 -0.532628 269.085C-65.4753 269.198 -118.03 321.937 -117.917 386.88C-117.803 451.822 -65.0649 504.377 -0.122164 504.264ZM112.149 386.478C112.258 448.597 61.988 499.043 -0.131087 499.151C-62.2502 499.259 -112.696 448.99 -112.804 386.871C-112.912 324.751 -62.6428 274.306 -0.523705 274.198C61.5954 274.089 112.041 324.359 112.149 386.478Z",
    fill: "url(#paint0_angular_9068_28935)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M-0.088702 523.436C75.4425 523.304 136.566 461.967 136.434 386.436C136.302 310.904 74.9651 249.781 -0.56609 249.913C-76.0973 250.045 -137.221 311.382 -137.089 386.913C-136.957 462.444 -75.6199 523.568 -0.088702 523.436ZM131.321 386.445C131.448 459.152 72.61 518.196 -0.0976251 518.323C-72.8052 518.45 -131.849 459.612 -131.976 386.904C-132.103 314.196 -73.2648 255.152 -0.557167 255.026C72.1505 254.899 131.195 313.737 131.321 386.445Z",
    fill: "url(#paint1_angular_9068_28935)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M155.606 386.402C155.756 472.522 86.0645 542.458 -0.0552402 542.608C-86.1749 542.758 -156.111 473.066 -156.261 386.946C-156.411 300.827 -86.7192 230.891 -0.599552 230.741C85.5202 230.59 155.456 300.282 155.606 386.402ZM-0.0641633 537.495C83.232 537.35 150.639 469.707 150.494 386.411C150.348 303.115 82.7055 235.708 -0.590629 235.853C-83.8868 235.999 -151.294 303.641 -151.148 386.938C-151.003 470.234 -83.3603 537.641 -0.0641633 537.495Z",
    fill: "url(#paint2_angular_9068_28935)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M174.778 386.369C174.947 483.077 96.6864 561.611 -0.0217784 561.78C-96.73 561.949 -175.264 483.688 -175.433 386.98C-175.602 290.272 -97.3412 211.737 -0.633014 211.569C96.0752 211.4 174.61 289.66 174.778 386.369ZM-0.0307015 556.667C93.8539 556.504 169.83 480.262 169.666 386.378C169.502 292.493 93.2605 216.517 -0.624091 216.681C-94.5087 216.845 -170.484 293.086 -170.32 386.971C-170.157 480.856 -93.9153 556.831 -0.0307015 556.667Z",
    fill: "url(#paint3_angular_9068_28935)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M193.95 386.335C194.138 493.632 107.308 580.765 0.0116834 580.952C-107.285 581.139 -194.418 494.31 -194.605 387.013C-194.793 279.717 -107.963 192.584 -0.666476 192.396C106.63 192.209 193.763 279.039 193.95 386.335ZM0.00276028 575.84C104.476 575.657 189.02 490.817 188.838 386.344C188.656 281.871 103.816 197.327 -0.657552 197.509C-105.131 197.691 -189.675 282.531 -189.493 387.004C-189.31 491.478 -104.47 576.022 0.00276028 575.84Z",
    fill: "url(#paint4_angular_9068_28935)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.0451452 600.124C117.93 599.919 213.328 504.187 213.123 386.302C212.917 268.417 117.185 173.019 -0.699937 173.224C-118.585 173.43 -213.983 269.162 -213.777 387.047C-213.572 504.932 -117.84 600.33 0.0451452 600.124ZM208.01 386.311C208.211 501.372 115.098 594.811 0.0362221 595.012C-115.025 595.213 -208.464 502.1 -208.665 387.038C-208.866 271.976 -115.753 178.538 -0.691014 178.337C114.371 178.136 207.809 271.249 208.01 386.311Z",
    fill: "url(#paint5_angular_9068_28935)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M232.295 386.268C232.519 514.742 128.552 619.072 0.078607 619.296C-128.395 619.521 -232.725 515.554 -232.95 387.08C-233.174 258.607 -129.207 154.276 -0.733399 154.052C127.74 153.828 232.071 257.795 232.295 386.268ZM0.0696838 614.184C125.72 613.965 227.401 511.927 227.182 386.277C226.963 260.627 124.926 158.945 -0.724476 159.165C-126.375 159.384 -228.056 261.421 -227.837 387.071C-227.618 512.721 -125.58 614.403 0.0696838 614.184Z",
    fill: "url(#paint6_angular_9068_28935)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.112069 638.469C139.174 638.226 251.71 525.297 251.467 386.235C251.224 247.173 138.295 134.637 -0.766861 134.88C-139.829 135.123 -252.364 248.052 -252.122 387.114C-251.879 526.176 -138.95 638.711 0.112069 638.469ZM246.354 386.244C246.592 522.482 136.342 633.118 0.103146 633.356C-136.135 633.594 -246.771 523.343 -247.009 387.105C-247.247 250.866 -136.996 140.23 -0.757938 139.993C135.481 139.755 246.117 250.005 246.354 386.244Z",
    fill: "url(#paint7_angular_9068_28935)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M270.639 386.201C270.9 535.852 149.796 657.38 0.145531 657.641C-149.505 657.902 -271.033 536.798 -271.294 387.147C-271.555 237.497 -150.451 115.969 -0.800323 115.708C148.85 115.447 270.378 236.551 270.639 386.201ZM0.136607 652.528C146.964 652.272 265.783 533.037 265.527 386.21C265.27 239.383 146.036 120.564 -0.7914 120.82C-147.618 121.077 -266.438 240.311 -266.181 387.138C-265.925 533.965 -146.69 652.784 0.136607 652.528Z",
    fill: "url(#paint8_angular_9068_28935)"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.178992 676.813C160.418 676.533 290.091 546.407 289.811 386.168C289.532 225.929 159.405 96.256 -0.833784 96.5357C-161.073 96.8154 -290.746 226.942 -290.466 387.181C-290.186 547.42 -160.06 677.093 0.178992 676.813ZM284.699 386.177C284.973 543.592 157.586 671.426 0.170069 671.7C-157.245 671.975 -285.079 544.587 -285.353 387.172C-285.628 229.756 -158.24 101.923 -0.824861 101.648C156.591 101.374 284.424 228.761 284.699 386.177Z",
    fill: "url(#paint9_angular_9068_28935)"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M308.983 386.134C309.282 556.962 171.04 695.687 0.212454 695.985C-170.615 696.283 -309.34 558.042 -309.638 387.214C-309.936 216.387 -171.695 77.6617 -0.867246 77.3636C169.96 77.0654 308.685 215.307 308.983 386.134ZM0.203531 690.873C168.208 690.579 304.164 554.147 303.871 386.143C303.578 218.139 167.146 82.1829 -0.858323 82.4761C-168.862 82.7693 -304.819 219.201 -304.526 387.205C-304.232 555.209 -167.8 691.166 0.203531 690.873Z",
    fill: "url(#paint10_angular_9068_28935)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.245916 715.157C181.662 714.841 328.472 567.517 328.156 386.101C327.839 204.685 180.515 57.8747 -0.900708 58.1913C-182.317 58.508 -329.127 205.832 -328.81 387.248C-328.494 568.664 -181.17 715.474 0.245916 715.157ZM323.043 386.11C323.355 564.702 178.83 709.733 0.236993 710.045C-178.356 710.356 -323.386 565.831 -323.698 387.239C-324.009 208.646 -179.484 63.6156 -0.891785 63.3039C177.701 62.9922 322.731 207.517 323.043 386.11Z",
    fill: "url(#paint11_angular_9068_28935)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M347.328 386.068C347.663 578.072 192.284 733.994 0.279378 734.329C-191.725 734.664 -347.647 579.286 -347.982 387.281C-348.318 195.276 -192.939 39.3543 -0.93417 39.0192C191.07 38.6841 346.993 194.063 347.328 386.068ZM0.270455 729.217C189.451 728.887 342.545 575.257 342.215 386.076C341.885 196.895 188.256 43.8016 -0.925247 44.1318C-190.106 44.462 -343.2 198.091 -342.87 387.272C-342.54 576.453 -188.911 729.547 0.270455 729.217Z",
    fill: "url(#paint12_angular_9068_28935)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.31284 753.502C202.906 753.148 366.853 588.627 366.5 386.034C366.146 183.441 201.625 19.4935 -0.967632 19.847C-203.561 20.2006 -367.508 184.721 -367.155 387.315C-366.801 589.908 -202.28 753.855 0.31284 753.502ZM361.387 386.043C361.736 585.812 200.073 748.04 0.303916 748.389C-199.466 748.738 -361.693 587.075 -362.042 387.306C-362.391 187.536 -200.728 25.3083 -0.958709 24.9596C198.811 24.611 361.039 186.274 361.387 386.043Z",
    fill: "url(#paint13_angular_9068_28935)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M385.672 386.001C386.044 599.182 213.528 772.302 0.346301 772.674C-212.835 773.046 -385.955 600.53 -386.327 387.348C-386.699 174.166 -214.183 1.04697 -1.00109 0.674893C212.18 0.302821 385.3 172.819 385.672 386.001ZM0.337378 767.561C210.695 767.194 380.927 596.368 380.559 386.01C380.192 175.652 209.366 5.42035 -0.99217 5.7875C-211.35 6.15464 -381.581 176.981 -381.214 387.339C-380.847 597.697 -210.021 767.928 0.337378 767.561Z",
    fill: "url(#paint14_angular_9068_28935)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_angular_9068_28935",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(-0.327396 386.674) rotate(-90.1) scale(386)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E300BF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.500086,
    stopColor: "#6A0059"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.500203,
    stopColor: "#E300BF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6A0059"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_angular_9068_28935",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(-0.327396 386.674) rotate(-90.1) scale(386)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E300BF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.500086,
    stopColor: "#6A0059"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.500203,
    stopColor: "#E300BF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6A0059"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint2_angular_9068_28935",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(-0.327396 386.674) rotate(-90.1) scale(386)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E300BF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.500086,
    stopColor: "#6A0059"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.500203,
    stopColor: "#E300BF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6A0059"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint3_angular_9068_28935",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(-0.327396 386.674) rotate(-90.1) scale(386)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E300BF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.500086,
    stopColor: "#6A0059"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.500203,
    stopColor: "#E300BF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6A0059"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint4_angular_9068_28935",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(-0.327396 386.674) rotate(-90.1) scale(386)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E300BF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.500086,
    stopColor: "#6A0059"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.500203,
    stopColor: "#E300BF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6A0059"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint5_angular_9068_28935",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(-0.327396 386.674) rotate(-90.1) scale(386)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E300BF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.500086,
    stopColor: "#6A0059"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.500203,
    stopColor: "#E300BF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6A0059"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint6_angular_9068_28935",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(-0.327396 386.674) rotate(-90.1) scale(386)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E300BF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.500086,
    stopColor: "#6A0059"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.500203,
    stopColor: "#E300BF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6A0059"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint7_angular_9068_28935",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(-0.327396 386.674) rotate(-90.1) scale(386)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E300BF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.500086,
    stopColor: "#6A0059"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.500203,
    stopColor: "#E300BF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6A0059"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint8_angular_9068_28935",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(-0.327396 386.674) rotate(-90.1) scale(386)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E300BF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.500086,
    stopColor: "#6A0059"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.500203,
    stopColor: "#E300BF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6A0059"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint9_angular_9068_28935",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(-0.327396 386.674) rotate(-90.1) scale(386)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E300BF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.500086,
    stopColor: "#6A0059"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.500203,
    stopColor: "#E300BF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6A0059"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint10_angular_9068_28935",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(-0.327396 386.674) rotate(-90.1) scale(386)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E300BF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.500086,
    stopColor: "#6A0059"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.500203,
    stopColor: "#E300BF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6A0059"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint11_angular_9068_28935",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(-0.327396 386.674) rotate(-90.1) scale(386)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E300BF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.500086,
    stopColor: "#6A0059"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.500203,
    stopColor: "#E300BF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6A0059"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint12_angular_9068_28935",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(-0.327396 386.674) rotate(-90.1) scale(386)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E300BF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.500086,
    stopColor: "#6A0059"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.500203,
    stopColor: "#E300BF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6A0059"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint13_angular_9068_28935",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(-0.327396 386.674) rotate(-90.1) scale(386)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E300BF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.500086,
    stopColor: "#6A0059"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.500203,
    stopColor: "#E300BF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6A0059"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint14_angular_9068_28935",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(-0.327396 386.674) rotate(-90.1) scale(386)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E300BF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.500086,
    stopColor: "#6A0059"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.500203,
    stopColor: "#E300BF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6A0059"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeroCircularShapeTradex);
export default __webpack_public_path__ + "static/media/hero-circular-shape-tradex.322aa88d60974d3f24ddebb102a51525.svg";
export { ForwardRef as ReactComponent };